import { Color } from '@gousto-internal/citrus-react';

export function statefulFilterTextStyle(recipeCount: number, isChecked: boolean | undefined) {
  if (recipeCount === 0) {
    return Color.NeutralGrey_200;
  }

  if (!isChecked) {
    return Color.ColdGrey_600;
  }

  return Color.White;
}
